// extracted by mini-css-extract-plugin
module.exports = {"container":"floorplanname_container__1L6LT","description":"floorplanname_description__2bEJt"};